import React from "react";
import isocertiimg1 from "../../Assets/Images/isoCertificationImg1.png";
import vision from "../../Assets/Images/visionIcon.png";
import mission from "../../Assets/Images/missionicon.png";
import tick from "../../Assets/Images/tickIcon.png";
import isocertiimg2 from "../../Assets/Images/isoCertificationImg2.png";
import getstartedimg from "../../Assets/Images/getStartedIcon.png";

const IsoCertification = () => {
  return (
    <div className="container iso-certification-section">
      <h2 className="iso-title">
        Trusted by Diverse <br /> Industries for Seamless <br /> ISO Certification
      </h2>

      <div className="iso-certification-grid">
        {/* Left Image */}
        <div className="iso-card image-card-one">
          <img src={isocertiimg1} alt="ISO Certification" />
        </div>

        {/* Vision */}
        <div className="iso-card vision-card">
          <img className="vision-icon" src={vision} alt="Vision" />
          <h5>Vision</h5>
          <p>
            To empower businesses worldwide with the trust, <br />
            and growth opportunities of ISO standards.
          </p>
        </div>

        {/* Right Image */}
        <div className="iso-card image-card-two">
          <img src={isocertiimg2} alt="ISO Certification" />
        </div>

        {/* Global + Trusted */}
        <div className="global">
          <div className="iso-card global-standards-card">
            <ul>
              <li>Global Standards</li>
              <li>Continuous Improvement</li>
              <li>Collaboration</li>
              <li>Accountability</li>
              <li>Excellence</li>
              <li>Sustainability</li>
            </ul>
          </div>
          <div className="iso-card trusted-card d-flex align-items-center">
            <img src={tick} alt="tick" />
            <p>Trusted by Diverse Industries for Smart ISO Solutions</p>
          </div>
        </div>

        {/* Mission */}
        <div className="iso-card mission-card">
          <img className="mission-icon" src={mission} alt="Mission" />
          <h5>Mission</h5>
          <p>
            To make ISO certification simple, fast, and highly <br />
            valuable for businesses of all sizes.
          </p>
        </div>

        {/* Our Values */}
        <div className="iso-card our-values-card">
          <h2>
            Our  Values
          </h2>
          <ul>
            <li>E — Excellence in Certification</li>
            <li>Q — Quality Assured</li>
            <li>C — Compliance with Global Standards</li>
            <li>A — Assurance & Accuracy</li>
            <li>S — Systematic & Reliable Service Approach</li>
          </ul>
        </div>

        {/* Get Started */}
        <div className="iso-card get-started-card">
          <div className="left">
            <img src={getstartedimg} alt="Get Started" />
            <p>Industry Trusted</p>
          </div>
          <button className="get-started-btn">GET STARTED NOW</button>
        </div>
      </div>
    </div>
  );
};

export default IsoCertification;
